import { Injectable } from '@angular/core';

import { CookieService } from 'ngx-cookie-service';

@Injectable({
  providedIn: 'root',
})
export class StorageService {
  constructor(private cookieService: CookieService) {}

  /** For adding a cookie
   * @param key - name of cookie
   * @param value - value to be stored
   * @param options - optional. additional options: expires?: number | Date | undefined, path?: string | undefined, domain?: string | undefined, secure?: boolean | undefined, sameSite?: SameSite | undefined
   */
  addCookie(key: string, value: any, ...options: any[]) {
    this.cookieService.set(key, value, ...options);
  }

  /** For adding an item to local storage
   * @param key - name of item
   * @param value - value to be stored
   */
  addToLocalStorage(key: string, value: any) {
    localStorage.setItem(key, JSON.stringify(value));
  }

  /** For adding an item to session storage
   * @param key - name of item
   * @param value - value to be stored
   */
  addToSessionStorage(key: string, value: any) {
    sessionStorage.setItem(key, JSON.stringify(value));
  }

  /** For clearing all cookies
   * @param options - optional. additional options: path?: string | undefined, domain?: string | undefined, secure?: boolean | undefined, sameSite?: SameSite | undefined
   */
  clearCookies(...options: any[]): void {
    this.cookieService.deleteAll(...options);
  }

  /** For clearing all items from local storage
   */
  clearLocalStorage(): void {
    localStorage.clear();
  }

  /** For clearing all items from session storage
   */
  clearSessionStorage(): void {
    sessionStorage.clear();
  }

  /** For deleting a cookie
   * @param key - name of cookie
   * @param options - optional. additional options: path?: string | undefined, domain?: string | undefined, secure?: boolean | undefined, sameSite?: SameSite | undefined
   */
  deleteCookie(key: string, ...options: any[]): any {
    this.cookieService.delete(key, ...options);
  }

  /** For deleting an item from local storage
   * @param key - name of item
   */
  deleteFromLocalStorage(key: string): any {
    localStorage.removeItem(key);
  }

  /** For deleting an item from session storage
   * @param key - name of item
   */
  deleteFromSessionStorage(key: string): any {
    sessionStorage.removeItem(key);
  }

  /** For getting a cookie
   * @param key - name of cookie
   */
  getCookie(key: string): any {
    return this.cookieService.get(key);
  }

  /** For getting an item from local storage
   * @param key - name of item
   */
  getFromLocalStorage(key: string): any {
    const item = localStorage.getItem(key);

    return item != null ? JSON.parse(item) : null;
  }

  /** For getting an item from session storage
   * @param key - name of item
   */
  getFromSessionStorage(key: string): any {
    const item = sessionStorage.getItem(key);

    return item != null ? JSON.parse(item) : null;
  }
}
